/* 强调-浮动 */
import AnimationModel from '@src/slide/domain/ui-model/element-modeles/anim-model';
import { IAnimModel } from '@src/slide/domain/ui-model/element-modeles/Interface/anim-model.interface';
import { AnimType } from '@tencent/slide-sdk-model';
import { PLAY_MODE } from '../constants';
import { getAnimDuration, getSlideWidthAndHeight, getTnRotate, isRightAnimType } from '../utils';

export const getEntrFloatToStyle = (timeNode: AnimationModel | IAnimModel, playMode: PLAY_MODE) => {
    if (!isRightAnimType(timeNode, playMode, AnimType.EntrFloat)) return {};
    const objRotate = getTnRotate(timeNode);
    const duration = getAnimDuration(timeNode, playMode);
    const { slideHeight, slideWidth } = getSlideWidthAndHeight(timeNode, playMode);
    const tempToStyle  = {
        opacity: [
            { value: 1, duration: 0.8 * duration },
            { value: 1, duration: 0.2 * duration },
        ],
        translateX: [
            { value: -0.05 * slideWidth, duration: 0.8 * duration },
            { value: 0, duration: 0.2 * duration },
        ],
        translateY: [
            { value: 0.1 * slideHeight, duration: 0.8 * duration },
            { value: 0, duration: 0.2 * duration },
        ],
        rotate: [
            { value: objRotate, duration: 0.8 * duration },
            { value: objRotate, duration: 0.2 * duration },
        ],
    };
    return tempToStyle;
};

export const getExitFloatToStyle  = (timeNode: AnimationModel | IAnimModel, playMode: PLAY_MODE) => {
    if (!isRightAnimType(timeNode, playMode, AnimType.ExitFloat)) return {};
    const objRotate = getTnRotate(timeNode);
    const duration = getAnimDuration(timeNode, playMode);
    const { slideWidth, slideHeight } = getSlideWidthAndHeight(timeNode, playMode);
    const tempToStyle = {
        opacity: [
            { value: 1, duration: 0.2 * duration },
            { value: 0, duration: 0.8 * duration },
        ],
        translateX: [
            { value: -0.05 * slideWidth, duration: 0.2 * duration },
            { value: 0.45 * slideWidth, duration: 0.8 * duration },
        ],
        translateY: [
            { value: 0.1 * slideHeight, duration: 0.2 * duration },
            { value: -0.5 * slideHeight, duration: 0.8 * duration },
        ],
        rotate: [
            { value: objRotate, duration: 0.2 * duration },
            { value: -90 + objRotate, duration: 0.8 * duration },
        ],
    };
    return tempToStyle;
};
